import { useMsgServer, useRoomBaseServer, useVirtualAudienceServer } from 'middle-domain';
import { hideFavicon } from '@/app-shared/utils/common';
import { probe } from '@/app-shared/utils/getBrowserType';
export const getEmbedVideoConfigs = async function () {
  const roomBaseServer = useRoomBaseServer();

  if (!roomBaseServer) {
    throw Error('get roomBaseServer exception');
  }

  const promiseList = [
    // configList 和 黄金链路串行执行
    roomBaseServer.getConfigList({ scene_id: 3 }),
    //多语言接口
    // roomBaseServer.getLangList(),
    roomBaseServer.getUnionConfig()
  ];

  return await Promise.all(promiseList);
};

export default async function () {
  console.log('%c------服务初始化 开始', 'color:blue');
  const roomBaseServer = useRoomBaseServer();
  const msgServer = useMsgServer();
  const virtualAudienceServer = useVirtualAudienceServer();

  if (!roomBaseServer) {
    throw Error('get roomBaseServer exception');
  }

  const configList = roomBaseServer.state.configList;
  !configList['ui.hide_favicon'] && hideFavicon();
  console.log('%c------黄金链路请求配置项完成', 'color:pink');
  console.log(roomBaseServer.state.configList);
  console.log('%c------多语言请求配置', 'color:pink');
  console.log(roomBaseServer.state.languages);

  // TODO 设置观看端测试权限数据
  // roomBaseServer.state.configList = {
  //   hasToolbar: false
  // };
  msgServer.init();
  console.log('%c------服务初始化 msgServer 初始化完成', 'color:blue');

  virtualAudienceServer.init();
}
export function isMSECanUse() {
  let mse = false;
  probe({}, data => {
    mse = data.MediaSourceExtensions;
  });
  return mse;
}
